module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Bold.7baf956c.eot";